export const SENTRY_ENVIRONMENT = import.meta.env
  .VITE_LIFELINE_CHAT_SURVEY_ENVIRONMENT;
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
